<template>
  <b-container
    v-if="renderPage"
    fluid
  >
    <h3 class="text-center">
      Soluções de Pagamento
    </h3>
    <br>
    <b-row>
      <div class="cards-wrapper">
        <b-card
          align="center"
          style="min-width: 280px; max-width: 320px"
        >
           <b-img
            center
            fluid
            src="@/assets/images/products/payment1.png"
          />
          <br>
          <br />
          <b-card-title align="center">Pagamentos Presenciais</b-card-title>
          <b-card-text align="center">
            Tenha a solução de captura presencial com taxas e condições
            adequadas ao seu tipo de negócio!
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/ecommerce.png" />
          <br />
          <b-card-title align="center">Pagamentos Online</b-card-title>
          <b-card-text align="center">
            Venda para seus clientes de forma pontual ou recorrente através do
            seu site, boletos ou link de pagamento!
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>
      </div>
    </b-row>
    <br />

    <h3 class="text-center">Soluções de Crédito</h3>
    <br />
    <b-row>
      <div class="cards-wrapper">
        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/antecipated.png" />
          <br />
          <b-card-title>Antecipação e Recebíveis</b-card-title>
          <b-card-text>
            Antecipe seus títulos de vendas a prazo e melhore o fluxo de caixa
            do seu negócio!
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/promotion.png" />
          <br />
          <b-card-title align="center">Fomento à Produção</b-card-title>
          <b-card-text align="center">
            Aumente a produção através da aquisição de matéria-prima pagando
            diretamente seus fornecedores à vista e negociando valores mais
            atrativos a prazo!
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/provider.png" />
          <br />
          <b-card-title align="center">Pool de Fornecedores</b-card-title>
          <b-card-text align="center">
            Melhore as condições de crédito junto aos seus fornecedores por meio
            de uma estrutura personalizada!
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/cashflow.png" />
          <br />
          <b-card-title>Convênio Multicedente e Monosacado</b-card-title>
          <b-card-text align="center">
            Otimize suas relações comerciais! Auxilie seus fornecedores a terem
            crédito à vista e permaneça pagando a prazo.
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/private.png" />
          <br />
          <b-card-title align="center">Consignado Privado</b-card-title>
          <b-card-text align="center">
            Ofereça aos seus colaboradores CLT empréstimos com as menores taxas
            do mercado e processo menos burocrático.
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>
      </div>
    </b-row>

    <br />
    <h3 class="text-center">Investimentos/Consultoria - FIDC</h3>
    <br />
    <b-row>
      <div class="cards-wrapper">
        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/invest.png" />
          <br />
          <b-card-title align="center">Investimento</b-card-title>
          <b-card-text align="center">
            Descubra opções de investimentos para pessoas físicas e jurídicas,
            com soluções compatíveis aos interesses de cada perfil.
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/finance.png" />
          <br />
          <b-card-title align="center">
            Consultoria para estruturação de fundos exclusivos
          </b-card-title>
          <b-card-text align="center">
            Tenha um auxílio especializado para a escolha do melhor fundo,
            sempre analisando os objetivos, o período do investimento e as
            características do negócio do cliente e da composição do fundo.
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>
      </div>
    </b-row>

    <br />
    <h3 class="text-center" data-aos="zoom-in" data-aos-duration="1000">
      Outras Soluções
    </h3>
    <br />
    <b-row>
      <div class="cards-wrapper">
        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/admaccount.png" />
          <br />
          <b-card-title align="center">
            Administração de Contas a Pagar e a Receber
          </b-card-title>
          <b-card-text align="center">
            Compartilhe a gestão financeira de sua empresa conosco e tenha mais
            tempo para focar no seu negócio!
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/analyst.png" />
          <br />
          <b-card-title align="center">
            Consultoria de crédito e cobrança
          </b-card-title>
          <b-card-text align="center">
            Melhore a análise de crédito, mitigue riscos e diminua a
            inadimplência através de uma política eficiente de crédito e
            cobrança especializada!
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>

        <b-card
          align="center"
          data-aos="zoom-in"
          data-aos-duration="1000"
          style="min-width: 280px; max-width: 320px"
        >
          <b-img center fluid src="@/assets/images/products/analyst.png" />
          <br />
          <b-card-title align="center">Banco Via</b-card-title>
          <b-card-text align="center">
            Utilize a conta digital empresarial do Grupo ViaInvest e melhore sua
            experiência de recebimento das soluções utilizadas.
          </b-card-text>
          <template #footer>
            <b-link :href="learnMoreHref">Saiba Mais</b-link>
          </template>
        </b-card>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import {
  BCard,
  BCardText,
  BRow,
  BImg,
  BLink,
  BContainer,
  BCardTitle,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BImg,
    BLink,
    BContainer,
    BCardTitle,
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false;
    next();
  },
  data() {
    return {
      learnMoreHref:
        "https://api.whatsapp.com/send?1=pt_BR&phone=551155552144&text=Olá%2C%20Quero%20falar%20com%20um%20especialista",
      renderPage: true,
    };
  },
  created() {
    AOS.init({
      offset: 120,
      delay: 0,
      duration: 100,
      easing: "ease-in",
      once: true,
      anchorPlacement: "top-bottom",
    });
  },
};
</script>

<style>
.b-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
  justify-content: center !important;
}

.cards-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 1.5rem;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 1rem; 
  box-sizing: border-box;
}

.cards-wrapper .card:hover {
  transform: translateY(-20px); 
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3); 
  border-color: #007bff44;
  background-color: #fafafa;
}
</style>
